webpackJsonp([0],{

/***/ "/t0r":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.list-progress__bar .v-progress-circular__underlay {\n  stroke: rgba(255,255,255,0.25);\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/recommendations/ProgressBar.vue"],"names":[],"mappings":";AACA;EACE,+BAA+B;CAChC","file":"ProgressBar.vue","sourcesContent":["\n.list-progress__bar .v-progress-circular__underlay {\n  stroke: rgba(255,255,255,0.25);\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "1rmJ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("/t0r");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("1f695c06", content, true, {});

/***/ }),

/***/ "2Pgn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.service-type-placeholder {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/recommendations/ServiceTypePlaceholder.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC","file":"ServiceTypePlaceholder.vue","sourcesContent":["\n.service-type-placeholder {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "9jZt":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HYS8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("6967758e", content, true, {});

/***/ }),

/***/ "ALNi":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Kubj");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("0f56e0ab", content, true, {});

/***/ }),

/***/ "B9go":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.panel-st__header {\n  color: #fff;\n  text-decoration: none;\n}\n.panel-st__label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.panel-st__card {\n  min-height: 20rem;\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/recommendations/ServiceType.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,sBAAsB;CACvB;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;CACzB;AACD;EACE,kBAAkB;CACnB","file":"ServiceType.vue","sourcesContent":["\n.panel-st__header {\n  color: #fff;\n  text-decoration: none;\n}\n.panel-st__label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.panel-st__card {\n  min-height: 20rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "BfD5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.st-recommendations__search {\n  width: 100%;\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/recommendations/ServiceTypeRecommendations.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb","file":"ServiceTypeRecommendations.vue","sourcesContent":["\n.st-recommendations__search {\n  width: 100%;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "DzZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./frontend/src/helpers/site_urls.js
var site_urls = __webpack_require__("N/+9");

// EXTERNAL MODULE: ./frontend/src/helpers/providers.js
var providers = __webpack_require__("gT2k");

// EXTERNAL MODULE: ./frontend/src/components/common/AvatarLogo.vue + 2 modules
var AvatarLogo = __webpack_require__("tZ6I");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/list/Account.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Account = ({
  data: function data() {
    return {};
  },

  props: ['folder', 'editMode'],
  computed: {
    provider: function provider() {
      return this.folder.provider;
    },
    followUrl: function followUrl() {
      return site_urls["a" /* default */].secureSite + '/follows/' + this.folder.uuid;
    },
    hasProvider: function hasProvider() {
      return !!this.provider;
    },
    logo: function logo() {
      return this.hasProvider && Object(providers["b" /* logoFor */])(this.provider, { size: 'small' });
    },
    serviceTypeLabel: function serviceTypeLabel() {
      return this.folder.service_types.map(function (st) {
        return st.name;
      }).join(', ');
    },
    label: function label() {
      if (this.folder.label) {
        return this.folder.label;
      } else {
        return this.serviceTypeLabel;
      }
    }
  },
  components: {
    AvatarLogo: AvatarLogo["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c9ddbb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/list/Account.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{staticClass:"list-account",attrs:{"avatar":"","ripple":"","href":_vm.followUrl}},[(_vm.logo)?_c('div',{staticClass:"v-list__tile__avatar"},[_c('avatar-logo',{attrs:{"src":_vm.logo,"alt":_vm.provider.name}})],1):_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey lighten-1 white--text"},[_vm._v("domain")])],1),_c('v-list-tile-content',[_c('v-list-tile-title',{attrs:{"title":_vm.provider.name}},[_vm._v(_vm._s(_vm.provider.name))]),(_vm.label)?_c('v-list-tile-sub-title',{attrs:{"title":_vm.label}},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./frontend/src/components/list/Account.vue
function injectStyle (context) {
  __webpack_require__("9jZt")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  Account,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var list_Account = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/list/Accounts.vue


//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Accounts = ({
  data: function data() {
    return {
      editMode: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('user', ['isLoggedIn']), Object(vuex_esm["d" /* mapState */])('folders', ['folders']), {
    sortedFolders: function sortedFolders() {
      // Sort alphabetically
      return this.folders.sort(function (first, second) {
        var a = first.provider.name.toLowerCase();
        var b = second.provider.name.toLowerCase();
        if (a === b) {
          return 0;
        }
        if ((typeof a === 'undefined' ? 'undefined' : typeof_default()(a)) === (typeof b === 'undefined' ? 'undefined' : typeof_default()(b))) {
          return a < b ? -1 : 1;
        }
        return (typeof a === 'undefined' ? 'undefined' : typeof_default()(a)) < (typeof b === 'undefined' ? 'undefined' : typeof_default()(b)) ? -1 : 1;
      });
    }
  }),
  methods: {
    getFolders: function getFolders() {
      if (this.isLoggedIn) {
        this.$store.dispatch('folders/getFolders');
      }
    }
  },
  mounted: function mounted() {
    if (this.folders == null) {
      this.getFolders();
    }
  },

  components: {
    Account: list_Account
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39bb2894","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/list/Accounts.vue
var Accounts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accounts-list"},[(_vm.folders)?_c('v-list',{staticClass:"pb-0 pt-0",attrs:{"light":""}},[_vm._l((_vm.sortedFolders),function(folder){return [_c('account',{key:folder.id,attrs:{"folder":folder,"edit-mode":_vm.editMode}}),_c('v-divider',{staticClass:"accounts-list__divider"})]})],2):_vm._e()],1)}
var Accounts_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/list/Accounts.vue
function Accounts_injectStyle (context) {
  __webpack_require__("UbkO")
}
/* script */


/* template */

/* template functional */
var Accounts___vue_template_functional__ = false
/* styles */
var Accounts___vue_styles__ = Accounts_injectStyle
/* scopeId */
var Accounts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Accounts___vue_module_identifier__ = null

var Accounts_Component = Object(component_normalizer["a" /* default */])(
  Accounts,
  Accounts_render,
  Accounts_staticRenderFns,
  Accounts___vue_template_functional__,
  Accounts___vue_styles__,
  Accounts___vue_scopeId__,
  Accounts___vue_module_identifier__
)

/* harmony default export */ var list_Accounts = (Accounts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/list/AccountsHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AccountsHeader = ({
  computed: {
    returnUrl: function returnUrl() {
      return site_urls["a" /* default */].secureSite;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db3b8da","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/list/AccountsHeader.vue
var AccountsHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accounts-header"},[_c('v-list',{staticClass:"py-0",attrs:{"dark":"","dense":""}},[_c('v-list-tile',{staticClass:"v-list__tile--divider accounts-header__all-tile",attrs:{"avatar":"","ripple":"","href":_vm.returnUrl}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"large":"","color":"white"}},[_vm._v("\n          home\n        ")])],1),_c('v-list-tile-content',[_vm._v("\n        Home\n      ")]),_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("keyboard_arrow_right")])],1)],1)],1)],1)}
var AccountsHeader_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/list/AccountsHeader.vue
function AccountsHeader_injectStyle (context) {
  __webpack_require__("ALNi")
}
/* script */


/* template */

/* template functional */
var AccountsHeader___vue_template_functional__ = false
/* styles */
var AccountsHeader___vue_styles__ = AccountsHeader_injectStyle
/* scopeId */
var AccountsHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccountsHeader___vue_module_identifier__ = null

var AccountsHeader_Component = Object(component_normalizer["a" /* default */])(
  AccountsHeader,
  AccountsHeader_render,
  AccountsHeader_staticRenderFns,
  AccountsHeader___vue_template_functional__,
  AccountsHeader___vue_styles__,
  AccountsHeader___vue_scopeId__,
  AccountsHeader___vue_module_identifier__
)

/* harmony default export */ var list_AccountsHeader = (AccountsHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-687e5a1f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/list/PublicHeader.vue
var PublicHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var PublicHeader_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v("Bills & Accounts")])],1),_c('v-list',{staticClass:"pb-0",attrs:{"subheader":""}},[_c('v-subheader',{staticClass:"caption"},[_vm._v("Organize & pay all your bills in one place")])],1)],1)}]

// CONCATENATED MODULE: ./frontend/src/components/list/PublicHeader.vue
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var PublicHeader___vue_template_functional__ = false
/* styles */
var PublicHeader___vue_styles__ = null
/* scopeId */
var PublicHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublicHeader___vue_module_identifier__ = null

var PublicHeader_Component = Object(component_normalizer["a" /* default */])(
  __vue_script__,
  PublicHeader_render,
  PublicHeader_staticRenderFns,
  PublicHeader___vue_template_functional__,
  PublicHeader___vue_styles__,
  PublicHeader___vue_scopeId__,
  PublicHeader___vue_module_identifier__
)

/* harmony default export */ var PublicHeader = (PublicHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/recommendations/ProgressBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ProgressBar = ({
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])('recommendations', ['progress']), {
    progressBarValue: function progressBarValue() {
      return this.progress ? this.progress : 0;
    },

    progressBarStyle: function progressBarStyle() {
      return {
        width: this.progress + '%',
        minWidth: '2em'
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fed2bb2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/ProgressBar.vue
var ProgressBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"pb-0 pt-4 grey darken-4 list-progress"},[_c('v-subheader',{staticClass:"mb-0 pb-4"},[_c('v-progress-circular',{staticClass:"mr-2 list-progress__bar",attrs:{"size":48,"width":6,"rotate":270,"value":_vm.progressBarValue,"color":"success"}},[_vm._v("\n      "+_vm._s(_vm.progressBarValue)+"%\n    ")]),_vm._v("\n    Complete your Account List:\n  ")],1),_c('v-divider')],1)}
var ProgressBar_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/ProgressBar.vue
function ProgressBar_injectStyle (context) {
  __webpack_require__("1rmJ")
}
/* script */


/* template */

/* template functional */
var ProgressBar___vue_template_functional__ = false
/* styles */
var ProgressBar___vue_styles__ = ProgressBar_injectStyle
/* scopeId */
var ProgressBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProgressBar___vue_module_identifier__ = null

var ProgressBar_Component = Object(component_normalizer["a" /* default */])(
  ProgressBar,
  ProgressBar_render,
  ProgressBar_staticRenderFns,
  ProgressBar___vue_template_functional__,
  ProgressBar___vue_styles__,
  ProgressBar___vue_scopeId__,
  ProgressBar___vue_module_identifier__
)

/* harmony default export */ var recommendations_ProgressBar = (ProgressBar_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e04ed1ee","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/ServiceTypePlaceholder.vue
var ServiceTypePlaceholder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-type-placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1)}
var ServiceTypePlaceholder_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/ServiceTypePlaceholder.vue
function ServiceTypePlaceholder_injectStyle (context) {
  __webpack_require__("kHA1")
}
/* script */
var ServiceTypePlaceholder___vue_script__ = null
/* template */

/* template functional */
var ServiceTypePlaceholder___vue_template_functional__ = false
/* styles */
var ServiceTypePlaceholder___vue_styles__ = ServiceTypePlaceholder_injectStyle
/* scopeId */
var ServiceTypePlaceholder___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServiceTypePlaceholder___vue_module_identifier__ = null

var ServiceTypePlaceholder_Component = Object(component_normalizer["a" /* default */])(
  ServiceTypePlaceholder___vue_script__,
  ServiceTypePlaceholder_render,
  ServiceTypePlaceholder_staticRenderFns,
  ServiceTypePlaceholder___vue_template_functional__,
  ServiceTypePlaceholder___vue_styles__,
  ServiceTypePlaceholder___vue_scopeId__,
  ServiceTypePlaceholder___vue_module_identifier__
)

/* harmony default export */ var ServiceTypePlaceholder = (ServiceTypePlaceholder_Component.exports);

// EXTERNAL MODULE: ./frontend/src/components/common/AddProviderLink.vue + 2 modules
var AddProviderLink = __webpack_require__("GQwO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/recommendations/PopularProviders.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PopularProviders = ({
  props: ['popularProviders', 'serviceType'],
  components: {
    AddProviderLink: AddProviderLink["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae724902","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/PopularProviders.vue
var PopularProviders_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popular-providers"},[(_vm.popularProviders && _vm.popularProviders.length)?_c('div',{staticClass:"popular-provider__list"},[_c('h4',{staticClass:"mb-2 grey--text"},[_vm._v("Or select from the most popular in your area:")]),_c('ul',{staticClass:"list--unstyled"},_vm._l((_vm.popularProviders),function(provider){return _c('li',[_c('add-provider-link',{staticClass:"blue--text text--accent-1",attrs:{"provider":provider,"service-types":[_vm.serviceType],"decoration":false}})],1)}))]):_c('h5',[_vm._v("Search to find and add your "+_vm._s(_vm.serviceType && _vm.serviceType.name || '')+" provider")])])}
var PopularProviders_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/PopularProviders.vue
/* script */


/* template */

/* template functional */
var PopularProviders___vue_template_functional__ = false
/* styles */
var PopularProviders___vue_styles__ = null
/* scopeId */
var PopularProviders___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PopularProviders___vue_module_identifier__ = null

var PopularProviders_Component = Object(component_normalizer["a" /* default */])(
  PopularProviders,
  PopularProviders_render,
  PopularProviders_staticRenderFns,
  PopularProviders___vue_template_functional__,
  PopularProviders___vue_styles__,
  PopularProviders___vue_scopeId__,
  PopularProviders___vue_module_identifier__
)

/* harmony default export */ var recommendations_PopularProviders = (PopularProviders_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/recommendations/ProviderSearchResults.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ProviderSearchResults = ({
  computed: {
    serviceTypesForAdd: function serviceTypesForAdd() {
      return this.serviceType ? [this.serviceType] : [];
    }
  },
  props: ['searchTerm', 'searchResults', 'serviceType'],
  components: {
    AddProviderLink: AddProviderLink["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4056558d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/ProviderSearchResults.vue
var ProviderSearchResults_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"provider-search"},[(_vm.searchResults.length)?_c('h4',{staticClass:"mb-2 grey--text"},[_vm._v("Search results for “"+_vm._s(_vm.searchTerm)+"”:")]):_vm._e(),(_vm.searchResults.length)?_c('ul',{staticClass:"list--unstyled mb-3"},_vm._l((_vm.searchResults),function(provider){return _c('li',[_c('add-provider-link',{staticClass:"blue--text text--accent-1",attrs:{"provider":provider,"service-types":_vm.serviceTypesForAdd,"decoration":false}})],1)})):_c('h4',{staticClass:"provider-search__noresults mb-2 grey--text text--lighten-3"},[_vm._v("\n    Your search for "),_c('strong',[_vm._v("“"+_vm._s(_vm.searchTerm)+"”")]),_vm._v(" didn’t return any results.\n  ")]),_c('h4',{staticClass:"mb-2 grey--text"},[_vm._v("\n    Don’t see your "+_vm._s(_vm.serviceType ? _vm.serviceType.name : '')+" provider?\n    "),_c('a',{staticClass:"white--text",attrs:{"role":"button","href":"/addbiller"}},[_vm._v("Add them!")])])])}
var ProviderSearchResults_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/ProviderSearchResults.vue
/* script */


/* template */

/* template functional */
var ProviderSearchResults___vue_template_functional__ = false
/* styles */
var ProviderSearchResults___vue_styles__ = null
/* scopeId */
var ProviderSearchResults___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProviderSearchResults___vue_module_identifier__ = null

var ProviderSearchResults_Component = Object(component_normalizer["a" /* default */])(
  ProviderSearchResults,
  ProviderSearchResults_render,
  ProviderSearchResults_staticRenderFns,
  ProviderSearchResults___vue_template_functional__,
  ProviderSearchResults___vue_styles__,
  ProviderSearchResults___vue_scopeId__,
  ProviderSearchResults___vue_module_identifier__
)

/* harmony default export */ var recommendations_ProviderSearchResults = (ProviderSearchResults_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/recommendations/ServiceTypeRecommendations.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ServiceTypeRecommendations = ({
  data: function data() {
    return {
      currentView: recommendations_PopularProviders,
      searchValue: '',
      searchTerm: '',
      searchResults: null,
      isLoading: false
    };
  },

  props: ['popularProviders', 'serviceType', 'isActive'],
  computed: {
    showResults: function showResults() {
      return Array.isArray(this.searchResults);
    }
  },
  watch: {
    isActive: function isActive(active) {
      if (!active) {
        this.searchValue = '';
      }
    },
    searchValue: function searchValue(value) {
      if (!value) {
        this.clearSearch();
      }
    }
  },
  methods: {
    clearSearch: function clearSearch() {
      this.searchTerm = '';
      this.searchResults = null;
      this.currentView = recommendations_PopularProviders;
      this.$refs.search.focus();
    },
    findProvider: function findProvider() {
      var _this = this;

      this.searchTerm = this.searchValue;
      this.isLoading = true;
      return axios_default.a.get('/list/providers', {
        params: {
          query: this.searchTerm,
          per_page: 8,
          max_count: 8
        }
      }).then(function (response) {
        _this.isLoading = false;
        _this.searchResults = response.data;
        _this.currentView = recommendations_ProviderSearchResults;
      });
      // TODO webpack (mikew): Add fail state for request
    },
    createNonListing: function createNonListing() {
      this.$store.dispatch('user/authenticate', {
        action: 'recommendations/setPendingNonListing',
        payload: this.serviceType
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-353bb97c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/ServiceTypeRecommendations.vue
var ServiceTypeRecommendations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-recommendations"},[_c('v-toolbar',{staticClass:"py-0",attrs:{"card":"","dense":"","color":"grey darken-4"}},[_c('v-form',{staticClass:"st-recommendations__search",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.findProvider($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{ref:"search",attrs:{"append-icon":_vm.searchValue.length ? 'close' : null,"loading":_vm.isLoading,"label":"search for your provider...","single-line":"","autofocus":"","color":"white","hide-details":""},on:{"click:append":function($event){_vm.searchValue = ''}},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}})],1),_c('v-flex',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":_vm.isLoading || !_vm.searchValue,"flat":"","dark":"","small":"","icon":""},on:{"click":_vm.findProvider}},[_c('v-icon',[_vm._v("search")])],1)],1)],1)],1)],1),_c('v-card-text',[_c(_vm.currentView,{tag:"component",attrs:{"search-term":_vm.searchTerm,"service-type":_vm.serviceType,"popular-providers":_vm.popularProviders,"search-results":_vm.searchResults}})],1),(!!_vm.serviceType)?_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","small":""},on:{"click":function($event){$event.preventDefault();return _vm.createNonListing($event)}}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("remove_circle")]),_vm._v("\n      I don't have this service\n    ")],1)],1):_vm._e()],1)}
var ServiceTypeRecommendations_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/ServiceTypeRecommendations.vue
function ServiceTypeRecommendations_injectStyle (context) {
  __webpack_require__("yC1i")
}
/* script */


/* template */

/* template functional */
var ServiceTypeRecommendations___vue_template_functional__ = false
/* styles */
var ServiceTypeRecommendations___vue_styles__ = ServiceTypeRecommendations_injectStyle
/* scopeId */
var ServiceTypeRecommendations___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServiceTypeRecommendations___vue_module_identifier__ = null

var ServiceTypeRecommendations_Component = Object(component_normalizer["a" /* default */])(
  ServiceTypeRecommendations,
  ServiceTypeRecommendations_render,
  ServiceTypeRecommendations_staticRenderFns,
  ServiceTypeRecommendations___vue_template_functional__,
  ServiceTypeRecommendations___vue_styles__,
  ServiceTypeRecommendations___vue_scopeId__,
  ServiceTypeRecommendations___vue_module_identifier__
)

/* harmony default export */ var recommendations_ServiceTypeRecommendations = (ServiceTypeRecommendations_Component.exports);

// EXTERNAL MODULE: ./node_modules/velocity-animate/velocity.js
var velocity = __webpack_require__("9qgI");
var velocity_default = /*#__PURE__*/__webpack_require__.n(velocity);

// CONCATENATED MODULE: ./frontend/src/mixins/sidebar.js


var easing = [0.25, 0.8, 0.25, 1];

/* harmony default export */ var sidebar = ({
  methods: {
    enter: function enter(el, done) {
      var container = document.getElementById('primary-nav');
      velocity_default()(el, 'slideDown', { easing: easing, duration: 350 });
      // Slide into view - don't assume sidebar is parent container
      if (container) {
        velocity_default()(el, 'scroll', { container: container, offset: -100, complete: done });
      } else {
        velocity_default()(el, 'scroll', { complete: done });
      }
    },
    leave: function leave(el, done) {
      velocity_default()(el, 'slideUp', { easing: easing, duration: 350, complete: done });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/recommendations/ServiceType.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var ServiceType = ({
  mixins: [sidebar],
  data: function data() {
    return {
      PopularProviders: null,
      currentView: ServiceTypePlaceholder
    };
  },

  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])('recommendations', ['activeServiceType']), {
    isActive: function isActive() {
      return this.activeServiceType === this.serviceType;
    },
    isLoaded: function isLoaded() {
      return Array.isArray(this.PopularProviders);
    }
  }),
  watch: {
    activeServiceType: function activeServiceType() {
      if (this.isActive && this.PopularProviders == null) {
        this.getRecommendations();
      }
    }
  },
  methods: {
    activatePanel: function activatePanel() {
      if (this.isActive) {
        this.$store.dispatch('recommendations/setActiveServiceType', null);
      } else {
        this.$store.dispatch('recommendations/setActiveServiceType', this.serviceType);
      }
    },
    getRecommendations: function getRecommendations() {
      var _this = this;

      return axios_default.a.get('/list/providers', {
        params: {
          service_type_id: this.serviceType.id
        }
      }).then(function (response) {
        _this.PopularProviders = response.data;
      });
      // TODO webpack (mikew): Add fail state for request
    }
  },
  props: ['serviceType'],
  components: {
    Placeholder: ServiceTypePlaceholder,
    ServiceTypeRecommendations: recommendations_ServiceTypeRecommendations
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-005523af","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/ServiceType.vue
var ServiceType_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-st v-expansion-panel__container",class:{ 'v-expansion-panel__container--active': _vm.isActive }},[_c('a',{staticClass:"v-expansion-panel__header panel-st__header",attrs:{"href":'#panel-service-type-' + _vm._uid,"title":'Add ' + _vm.serviceType.name},on:{"click":function($event){$event.preventDefault();return _vm.activatePanel($event)}}},[_c('h4',{staticClass:"panel-st__label"},[(_vm.isActive)?_c('span',[_vm._v("Add")]):_c('v-icon',{attrs:{"small":""}},[_vm._v("add_circle")]),_vm._v("\n      "+_vm._s(_vm.serviceType.name)+"\n    ")],1),_c('div',{staticClass:"v-expansion-panel__header__icon"},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)]),_c('transition',{attrs:{"css":false},on:{"enter":_vm.enter,"leave":_vm.leave}},[(_vm.isActive)?_c('div',{staticClass:"v-expansion-panel__body panel-st__body",attrs:{"id":'panel-service-type-' + _vm._uid}},[_c('v-card',{staticClass:"grey darken-4 panel-st__card"},[(_vm.isLoaded)?_c('service-type-recommendations',{attrs:{"popular-providers":_vm.PopularProviders,"service-type":_vm.serviceType,"is-active":_vm.isActive}}):_c('placeholder')],1)],1):_vm._e()])],1)}
var ServiceType_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/ServiceType.vue
function ServiceType_injectStyle (context) {
  __webpack_require__("kqMA")
}
/* script */


/* template */

/* template functional */
var ServiceType___vue_template_functional__ = false
/* styles */
var ServiceType___vue_styles__ = ServiceType_injectStyle
/* scopeId */
var ServiceType___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServiceType___vue_module_identifier__ = null

var ServiceType_Component = Object(component_normalizer["a" /* default */])(
  ServiceType,
  ServiceType_render,
  ServiceType_staticRenderFns,
  ServiceType___vue_template_functional__,
  ServiceType___vue_styles__,
  ServiceType___vue_scopeId__,
  ServiceType___vue_module_identifier__
)

/* harmony default export */ var recommendations_ServiceType = (ServiceType_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/recommendations/AddAnother.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var AddAnother = ({
  mixins: [sidebar],
  data: function data() {
    return {
      isActive: false
    };
  },
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])('folders', ['pending', 'folders']), {
    hasFollows: function hasFollows() {
      return this.folders && this.folders.length;
    }
  }),
  watch: {
    // Once pending, collapse the panel
    pending: function pending() {
      this.isActive = false;
    }
  },
  components: {
    ServiceTypeRecommendations: recommendations_ServiceTypeRecommendations
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4577c4b8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/AddAnother.vue
var AddAnother_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-add v-expansion-panel__container",class:{ 'v-expansion-panel__container--active': _vm.isActive }},[_c('a',{staticClass:"v-expansion-panel__header panel-add__header",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.isActive = !_vm.isActive}}},[_c('h4',{staticClass:"panel-add__label"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("add_circle")]),_vm._v("\n      Add "+_vm._s(_vm.hasFollows ? 'another' : 'an')+" account\n    ")],1),_c('div',{staticClass:"v-expansion-panel__header__icon"},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)]),_c('transition',{attrs:{"css":false},on:{"enter":_vm.enter,"leave":_vm.leave}},[(_vm.isActive)?_c('div',{staticClass:"v-expansion-panel__body panel-add__body"},[_c('v-card',{staticClass:"grey darken-4 panel-add__card"},[_c('service-type-recommendations',{attrs:{"popular-providers":[],"service-type":null,"is-active":_vm.isActive}})],1)],1):_vm._e()])],1)}
var AddAnother_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/AddAnother.vue
function AddAnother_injectStyle (context) {
  __webpack_require__("ZAgm")
}
/* script */


/* template */

/* template functional */
var AddAnother___vue_template_functional__ = false
/* styles */
var AddAnother___vue_styles__ = AddAnother_injectStyle
/* scopeId */
var AddAnother___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AddAnother___vue_module_identifier__ = null

var AddAnother_Component = Object(component_normalizer["a" /* default */])(
  AddAnother,
  AddAnother_render,
  AddAnother_staticRenderFns,
  AddAnother___vue_template_functional__,
  AddAnother___vue_styles__,
  AddAnother___vue_scopeId__,
  AddAnother___vue_module_identifier__
)

/* harmony default export */ var recommendations_AddAnother = (AddAnother_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/recommendations/ConfirmNonlisting.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ConfirmNonlisting = ({
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])('recommendations', ['pendingNonListing']), {
    isOpen: {
      get: function get() {
        return !!this.pendingNonListing;
      },
      set: function set() {
        this.$store.dispatch('recommendations/cancelNonListing');
      }
    },
    serviceType: function serviceType() {
      return this.pendingNonListing;
    }
  }),
  methods: {
    cancelNonListing: function cancelNonListing() {
      this.$store.dispatch('recommendations/cancelNonListing');
    },
    confirmNonListing: function confirmNonListing() {
      this.$store.dispatch('recommendations/createNonListing', this.serviceType);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-146cb720","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/ConfirmNonlisting.vue
var ConfirmNonlisting_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure?")]),(_vm.isOpen)?_c('v-card-text',{staticClass:"confirm-nonlisting-modal"},[_vm._v("doxo works best when you add all your bills for every type of service. Are you sure you have no "+_vm._s(_vm.serviceType.name)+" provider?")]):_vm._e(),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"flat":"flat"},on:{"click":function($event){$event.preventDefault();return _vm.cancelNonListing($event)}}},[_vm._v("Cancel")]),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){$event.preventDefault();return _vm.confirmNonListing($event)}}},[_vm._v("I'm sure")])],1)],1)],1)}
var ConfirmNonlisting_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/ConfirmNonlisting.vue
/* script */


/* template */

/* template functional */
var ConfirmNonlisting___vue_template_functional__ = false
/* styles */
var ConfirmNonlisting___vue_styles__ = null
/* scopeId */
var ConfirmNonlisting___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ConfirmNonlisting___vue_module_identifier__ = null

var ConfirmNonlisting_Component = Object(component_normalizer["a" /* default */])(
  ConfirmNonlisting,
  ConfirmNonlisting_render,
  ConfirmNonlisting_staticRenderFns,
  ConfirmNonlisting___vue_template_functional__,
  ConfirmNonlisting___vue_styles__,
  ConfirmNonlisting___vue_scopeId__,
  ConfirmNonlisting___vue_module_identifier__
)

/* harmony default export */ var recommendations_ConfirmNonlisting = (ConfirmNonlisting_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/recommendations/Index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Note (mikew): Expansion Panel styles used, but component not used since it doesn't support custom animations






/* harmony default export */ var Index = ({
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])('layout', ['expanded']), Object(vuex_esm["d" /* mapState */])('recommendations', ['remainingServiceTypes']), Object(vuex_esm["c" /* mapGetters */])('user', ['isLoggedIn']), {
    hasRemainingServiceTypes: function hasRemainingServiceTypes() {
      return this.remainingServiceTypes && this.remainingServiceTypes.length;
    }
  }),
  methods: {
    getRecommendations: function getRecommendations() {
      this.$store.dispatch('recommendations/getRemaining');
      if (this.isLoggedIn) {
        this.$store.dispatch('recommendations/getProgress');
      }
    }
  },
  components: {
    ProgressBar: recommendations_ProgressBar,
    ServiceType: recommendations_ServiceType,
    AddAnother: recommendations_AddAnother,
    ConfirmNonlistingModal: recommendations_ConfirmNonlisting
  },
  watch: {
    isLoggedIn: function isLoggedIn() {
      this.getRecommendations();
    }
  },
  mounted: function mounted() {
    this.getRecommendations();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3c61474","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/recommendations/Index.vue
var Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommendations pb-5",class:{'no-margin': _vm.remainingServiceTypes}},[(_vm.hasRemainingServiceTypes)?_c('progress-bar'):_vm._e(),_c('div',{staticClass:"v-expansion-panel"},[(_vm.remainingServiceTypes && _vm.remainingServiceTypes.length)?_vm._l((_vm.remainingServiceTypes),function(serviceType){return _c('service-type',{key:serviceType.id,attrs:{"service-type":serviceType}})}):_vm._e(),_c('add-another')],2),_c('confirm-nonlisting-modal')],1)}
var Index_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/recommendations/Index.vue
/* script */


/* template */

/* template functional */
var Index___vue_template_functional__ = false
/* styles */
var Index___vue_styles__ = null
/* scopeId */
var Index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Index___vue_module_identifier__ = null

var Index_Component = Object(component_normalizer["a" /* default */])(
  Index,
  Index_render,
  Index_staticRenderFns,
  Index___vue_template_functional__,
  Index___vue_styles__,
  Index___vue_scopeId__,
  Index___vue_module_identifier__
)

/* harmony default export */ var recommendations_Index = (Index_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/list/FeaturedProvider.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var FeaturedProvider = ({
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])('providers', ['provider']), {
    logo: function logo() {
      return Object(providers["b" /* logoFor */])(this.provider, { size: 'small' });
    },
    showProvider: function showProvider() {
      return this.provider && !Object(providers["a" /* foldersFor */])(this.provider).length;
    },
    linkTitle: function linkTitle() {
      return 'Add ' + this.provider.name + ' to your Bills &amp; Accounts List';
    }
  }),
  components: {
    AddProviderLink: AddProviderLink["a" /* default */],
    AvatarLogo: AvatarLogo["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58b56b24","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/list/FeaturedProvider.vue
var FeaturedProvider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showProvider)?_c('v-card',{staticClass:"sidebar-featured pb-4",attrs:{"color":"grey darken-2"}},[_c('v-card-title',{staticClass:"subheading sidebar-featured__heading"},[_vm._v("Add this account?")]),_c('v-list',{staticClass:"py-0",attrs:{"light":""}},[_c('li',[_c('add-provider-link',{staticClass:"v-list__tile v-list__tile--link v-list__tile--avatar",attrs:{"provider":_vm.provider,"title":_vm.linkTitle}},[(_vm.logo)?_c('div',{staticClass:"v-list__tile__avatar"},[_c('avatar-logo',{attrs:{"src":_vm.logo,"alt":_vm.provider.name}})],1):_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey lighten-1 white--text"},[_vm._v("domain")])],1),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.provider.name))])],1),_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("add_circle")])],1)],1)],1)])],1):_vm._e()}
var FeaturedProvider_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/list/FeaturedProvider.vue
/* script */


/* template */

/* template functional */
var FeaturedProvider___vue_template_functional__ = false
/* styles */
var FeaturedProvider___vue_styles__ = null
/* scopeId */
var FeaturedProvider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FeaturedProvider___vue_module_identifier__ = null

var FeaturedProvider_Component = Object(component_normalizer["a" /* default */])(
  FeaturedProvider,
  FeaturedProvider_render,
  FeaturedProvider_staticRenderFns,
  FeaturedProvider___vue_template_functional__,
  FeaturedProvider___vue_styles__,
  FeaturedProvider___vue_scopeId__,
  FeaturedProvider___vue_module_identifier__
)

/* harmony default export */ var list_FeaturedProvider = (FeaturedProvider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./frontend/src/components/list/Index.vue

//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var list_Index = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('user', ['isLoggedIn'])),
  components: {
    Accounts: list_Accounts,
    AccountsHeader: list_AccountsHeader,
    PublicHeader: PublicHeader,
    Recommendations: recommendations_Index,
    FeaturedProvider: list_FeaturedProvider
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5bd216c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/list/Index.vue
var list_Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoggedIn)?_c('public-header'):_vm._e(),_c('featured-provider'),(_vm.isLoggedIn)?_c('accounts-header'):_vm._e(),_c('accounts'),_c('recommendations')],1)}
var list_Index_staticRenderFns = []

// CONCATENATED MODULE: ./frontend/src/components/list/Index.vue
/* script */


/* template */

/* template functional */
var list_Index___vue_template_functional__ = false
/* styles */
var list_Index___vue_styles__ = null
/* scopeId */
var list_Index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var list_Index___vue_module_identifier__ = null

var list_Index_Component = Object(component_normalizer["a" /* default */])(
  list_Index,
  list_Index_render,
  list_Index_staticRenderFns,
  list_Index___vue_template_functional__,
  list_Index___vue_styles__,
  list_Index___vue_scopeId__,
  list_Index___vue_module_identifier__
)

/* harmony default export */ var components_list_Index = __webpack_exports__["default"] = (list_Index_Component.exports);


/***/ }),

/***/ "GJ08":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.accounts-list__divider {\n  background: rgba(0,0,0,0.12) !important;\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/list/Accounts.vue"],"names":[],"mappings":";AACA;EACE,wCAAwC;CACzC","file":"Accounts.vue","sourcesContent":["\n.accounts-list__divider {\n  background: rgba(0,0,0,0.12) !important;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "HYS8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.list-account--disabled {\n  pointer-events: none;\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/list/Account.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;CACtB","file":"Account.vue","sourcesContent":["\n.list-account--disabled {\n  pointer-events: none;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "Kubj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.accounts-header__all-tile .v-list__tile {\n  font-size: 16px;\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/list/AccountsHeader.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB","file":"AccountsHeader.vue","sourcesContent":["\n.accounts-header__all-tile .v-list__tile {\n  font-size: 16px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "T254":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "\n.panel-add__header {\n  color: #fff;\n  text-decoration: none;\n}\n.panel-add__label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.panel-add__card {\n  min-height: 20rem;\n}", "", {"version":3,"sources":["/home/appuser/frontend/src/components/recommendations/AddAnother.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,sBAAsB;CACvB;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;CACzB;AACD;EACE,kBAAkB;CACnB","file":"AddAnother.vue","sourcesContent":["\n.panel-add__header {\n  color: #fff;\n  text-decoration: none;\n}\n.panel-add__label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.panel-add__card {\n  min-height: 20rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "UbkO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GJ08");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("1f5c06de", content, true, {});

/***/ }),

/***/ "ZAgm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("T254");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("5d0231d1", content, true, {});

/***/ }),

/***/ "kHA1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2Pgn");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("2a2ea7de", content, true, {});

/***/ }),

/***/ "kqMA":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("B9go");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("887f8de2", content, true, {});

/***/ }),

/***/ "yC1i":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BfD5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("11c59471", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// 0-2a68749b908c95704771.js